import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { State } from '../store'
import { selectOwnDevices } from '../selectors/devices'
import { Typography } from '@mui/material'
import { OutOfBand } from '../components/OutOfBand'
import { Container } from '../components/Container'
import { Gutters } from '../components/Gutters'
import { Scan } from '../components/Scan'
import { emit } from '../services/Controller'

export const ScanPage: React.FC = () => {
  const { t } = useTranslation()
  const { interfaces, services, scanData, privateIP } = useSelector((state: State) => ({
    interfaces: state.backend.interfaces,
    services: selectOwnDevices(state).find(d => d.thisDevice)?.services || [],
    scanData: state.backend.scanData,
    privateIP: state.backend.environment.privateIP,
  }))

  useEffect(() => {
    emit('interfaces')
  }, [])

  return (
    <Container
      integrated
      header={
        <>
          <OutOfBand />
          <Typography variant="h1">{t('scanPage.title', 'Network Scan')}</Typography>
          <Gutters top={null}>
            <Typography variant="body2" color="textSecondary">
              {t('scanPage.description', 'Scan your system and local network for available ports to host.')}
            </Typography>
          </Gutters>
        </>
      }
    >
      <Scan data={scanData} services={services} interfaces={interfaces} privateIP={privateIP} />
    </Container>
  )
}
